// data/usePickingListDownload.ts
import { useCallback, useState } from "react";
import { resourceAPIURL } from "../config";
import { useAuth } from "../contexts/AuthContext";
import { fileNameFromContentDisposition } from "../utils/contentDisposition";

export default function usePickingListDownload() {
  const { token } = useAuth();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadPickingList = useCallback(async (partIds: string[]) => {
    if (!Array.isArray(partIds) || partIds.length === 0) {
      throw new Error("No items supplied");
    }

    setIsDownloading(true);

    try {
      const response = await fetch(`${resourceAPIURL}/api/part/picking/pdf`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": "true",
          Authorization: `Bearer ${token ?? ""}`,
          // Accept: "application/pdf",
        },
        body: JSON.stringify(partIds),
      });

      if (!response.ok) {
        throw new Error(`Failed to generate picking list (${response.status}).`);
      }

      const blob = await response.blob();
      const contentDisposition = response.headers.get("Content-Disposition");
      const fileName = fileNameFromContentDisposition(
        contentDisposition,
        `PickList-${new Date().toISOString().slice(0, 10)}.pdf`
      );

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
    } finally {
      setIsDownloading(false);
    }




    // try {
    //   const response = await fetch(`${resourceAPIURL}/api/part/picking/pdf`, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       "ngrok-skip-browser-warning": "true",
    //       Authorization: `Bearer ${token ?? ""}`,
    //       Accept: "application/pdf",
    //     },
    //     body: JSON.stringify(partIds),
    //   });

    //   if (!response.ok) {
    //     throw new Error(`Failed to generate picking list (${response.status}).`);
    //   }

    //   const blob = await response.blob();
    //   const fileName = getFilenameFromDisposition(
    //     response.headers.get("Content-Disposition"),
    //     `PickList-${new Date().toISOString().slice(0, 10)}.pdf`
    //   );

    //   const url = window.URL.createObjectURL(blob);
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", fileName);
    //   document.body.appendChild(link);
    //   link.click();
    //   link.remove();
    //   window.URL.revokeObjectURL(url);
    // } finally {
    //   setIsDownloading(false);
    // }
  }, [token]);

  return { downloadPickingList, isDownloading };
}
